import React, { useEffect, useContext } from "react";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { get_dashboard_index_data } from "../../store/reducers/dashboardReducer";
import { LanguageContext } from "../../context/LanguageContext";
const Index = () => {
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  const { totalOrder, pendingOrder, recentOrders, cancelledOrder } =
    useSelector((state) => state.dashboard);

  const dispatch = useDispatch();

  const { t } = useContext(LanguageContext);

  useEffect(() => {
    if (userInfo && userInfo.id)
      dispatch(get_dashboard_index_data(userInfo.id));
  }, [dispatch, userInfo]);

  const handleRedirect = (ord) => {
    const items = (ord.products || []).reduce(
      (sum, p) => sum + (p.quantity || 0),
      0,
    );
    navigate("/payment", {
      state: {
        price: ord.price,
        items,
        orderId: ord._id,
      },
    });
  };

  const paymentLabel = (status) => {
    if (!status) return "";
    const key = status?.toString().toLowerCase();
    const map = {
      paid: t("paymentPaid"),
      unpaid: t("paymentUnpaid"),
      pending: t("paymentPending"),
      failed: t("paymentFailedLabel"),
    };
    return map[key] || status;
  };

  const deliveryLabel = (status) => {
    if (!status) return "";
    const key = status?.toString().toLowerCase();
    const map = {
      placed: t("statusPlaced"),
      pending: t("statusPending"),
      cancelled: t("statusCancelled"),
      warehouse: t("statusWarehouse"),
      delivered: t("delivered") || "Delivered",
    };
    return map[key] || status;
  };
  return (
    <div>
      <div className="grid grid-cols-3 md:grid-cols-1 gap-5">
        <div className="flex justify-center items-center p-5 bg-white rounded-md gap-5">
          <div className="bg-green-100 w-[47px] h-[47px] rounded-full flex justify-center items-center text-xl ">
            <span className="text-xl text-green-800">
              <AiOutlineShoppingCart />
            </span>
          </div>
          <div className="flex flex-col justify-start items-start text-slate-600">
            <h2 className="text-3xl font-bold">{totalOrder}</h2>
            <span>{t("ordersLabel")}</span>
          </div>
        </div>
        <div className="flex justify-center items-center p-5 bg-white rounded-md gap-5">
          <div className="bg-blue-100 w-[47px] h-[47px] rounded-full flex justify-center items-center text-xl ">
            <span className="text-xl text-blue-800">
              <AiOutlineShoppingCart />
            </span>
          </div>
          <div className="flex flex-col justify-start items-start text-slate-600">
            <h2 className="text-3xl font-bold">{pendingOrder}</h2>
            <span>{t("pendingOrders")}</span>
          </div>
        </div>
        <div className="flex justify-center items-center p-5 bg-white rounded-md gap-5">
          <div className="bg-red-100 w-[47px] h-[47px] rounded-full flex justify-center items-center text-xl ">
            <span className="text-xl text-red-800">
              <AiOutlineShoppingCart />
            </span>
          </div>
          <div className="flex flex-col justify-start items-start text-slate-600">
            <h2 className="text-3xl font-bold">{cancelledOrder}</h2>
            <span>{t("cancelledOrders")}</span>
          </div>
        </div>
      </div>
      <div className="bg-white p-4 mt-5 rounded-md">
        <h2 className="text-lg font-semibold text-slate-600">
          {t("recentOrders")}
        </h2>
        <div className="pt-4">
          <div className="relative overflow-x-auto">
            <table className="w-full text-sm text-left text-gray-500">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    {t("orderId")}
                  </th>
                  <th scope="col" className="px-6 py-3">
                    {t("price")}
                  </th>
                  <th scope="col" className="px-6 py-3">
                    {t("paymentStatus")}
                  </th>
                  <th scope="col" className="px-6 py-3">
                    {t("orderStatus")}
                  </th>
                  <th scope="col" className="px-6 py-3">
                    {t("action")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {recentOrders.map((o) => (
                  <tr key={o._id} className="bg-white border-b">
                    <td className="px-6 py-4 font-medium whitespace-nowrap">
                      {o._id}
                    </td>
                    <td className="px-6 py-4 font-medium whitespace-nowrap">
                      {o.price} {t("currency")}
                    </td>
                    <td className="px-6 py-4 font-medium whitespace-nowrap">
                      {paymentLabel(o.payment_status)}
                    </td>
                    <td className="px-6 py-4 font-medium whitespace-nowrap">
                      {deliveryLabel(o.delivery_status)}
                    </td>
                    <td className="px-6 py-4">
                      <Link to={`/dashboard/order/details/${o._id}`}>
                        <span className="bg-green-100 text-green-800 text-sm font-normal mr-2 px-2.5 py-[1px] rounded">
                          {t("view")}
                        </span>
                      </Link>
                      {o.payment_status !== "paid" && (
                        <span
                          onClick={() => handleRedirect(o)}
                          className="bg-green-100 text-green-800 text-sm font-normal mr-2 px-2.5 py-[1px] rounded cursor-pointer"
                        >
                          {t("payNow")}
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
